<template>
  <div v-if="links.length > 3">
    <div class="pagination">
      <template v-for="(link, k) in links" :key="k">
        <div v-if="link.url === null"  class="page-item page-item-disabled" v-html="link.label" />
        <inertia-link v-else class="page-item" :class="{ 'active': link.active }" :href="`${link.url}#points-of-sale-grid-section`" v-html="link.label" preserve-state/>
      </template>
    </div>
  </div>
</template>

<script>
import {InertiaLink} from "@inertiajs/inertia-vue3";
export default {
  props: {
    links: Array,
  },
    components : {
    InertiaLink
  }
}
</script>
<style scoped>
.pagination {
  display: inline-block;
}

.pagination a, .pagination div {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
}
.pagination .active {
  color: red;
}

.pagination div.page-item-disabled {
    opacity: 0.4;
}
</style>
